module.exports = __webpack_public_path__ + "images/emoji/cat.dcbf28f5dd8d70667212.png";